/**
 * @property setCreatedUserId
 */
const Item = {
    Excise: 0,
    tmpExcise: 0,
    Name: '',
    Type: '',
    Supplier: '',
    QualityPassport: '',
    Id: '',
    VATRate: '',
    ProductId: '',
    Density: 0,
    GrossPricePerTonne: '',
    GrossPricePerLitre: '',
    AmountInTonne: '',
    AmountInLitre: '',
    NetPricePerTonne: '',
    PricePerTonneNoVAT: '',
    VATPerTonne: '',
    CreatedUserId: '',
    TotalPriceInText: ''
}

// for (const key of Object.keys(Item)) {
//     Object.defineProperty(Item, 'set' + key, {
//         set(value) {
//             this[key] = value
//         },
//         get() {
//             return this[key]
//         },
//         configurable: true,
//         enumerable: true
//     })
// }

Object.defineProperty(Item, 'setNewVlues', {
    value: function (params) {
        if (!params) return this
        for (const key of Object.keys(params)) {
            this[key] = params[key]
        }
        return this
    },
    configurable: true,
    enumerable: true,
    writable: true
})

export class Container {
    static ProductItem = Item
}
